import styles from "../../../styles/Page-with-Sidebar.module.css"
import eccss from "../../../styles/ExternalCalls.module.css"
import { useContext, useState, useEffect, useRef, useCallback } from "react"
import PageSidebarContent from "../../../components/sidebars/PageSidebarContent"
import AdditionalServicesSidebar from "../../../components/sidebars/AdditionalServicesSidebar"
import LoaderFullPage from "../../../components/Loaders"
import { UserContext } from "../../../context/userContext"
import { Toast } from "primereact/toast"
import {
  trApiFindStaffAndOrgNumber,
  trApiGetExternalCallHistory,
  trApiGetTwilioAudioToken,
  trApiGetPhoneSuggestions,
  trApiAddParticipantExternalCall,
  trApiDisconnectExternalCall,
} from "../telerecoveryApi"
import moment from "moment"
import {
  formatPhoneNumber,
  cleanPhoneNumber,
  formatPhoneNumberInput,
} from "../Utils"
import AudioSessionTimer from "../Audio/AudioSessionTimer"
import { Button } from "primereact/button"
import CallErrorPopup from "../AlertPopup"
import { Device } from "@twilio/voice-sdk"
import { usePrompt } from "../../../hooks/usePrompt"
import CallHistory from "./CallHistory"
import { HubConnectionBuilder } from "@microsoft/signalr"
import PhoneAutocomplete from "./PhoneAutocomplete"
import { RadioButton } from "primereact/radiobutton"
import hangup_icon from "../resources/hangup.svg"
import mic_icon from "../resources/mic.svg"
import send_icon from "../resources/send_2.svg"
import participant_icon from "../resources/participant.svg"
import remove_icon from "../resources/remove.svg"
import mic_off_icon from "../resources/mic_off.svg"
import { validatePhoneNumber } from "../Utils"
import { telerecoveryApiUrl } from "../../../config/microservicesUrls"
import PhoneKeypad from "./PhoneKeypad"
import { classNames } from "primereact/utils"

const ExternalCalls = () => {
  const [loadingCalls, setLoadingCalls] = useState(false)
  const [loadingSuggestions, setLoadingSuggestions] = useState(false)
  const [fromNumber, setFromNumber] = useState(null)
  const [toNumber, setToNumber] = useState(null)
  const [toNumbers, setToNumbers] = useState([])
  const [callHistory, setCallHistory] = useState([])
  const toast = useRef(null)
  const [errorFindingNumbers, setErrorFindingNumbers] = useState(null)
  const [fromNumbers, setFromNumbers] = useState([])
  const [loadingNumbers, setLoadingNumbers] = useState(false)
  const userCtx = useContext(UserContext)
  const [activeCall, setActiveCall] = useState(null)
  const [status, setStatus] = useState("No call in progress.")
  const [isDeviceReady, setIsDeviceReady] = useState(false)
  const [isMuted, setIsMuted] = useState(false)
  const [isOnCall, setIsOnCall] = useState(false)
  const [callError, setCallError] = useState("")
  const [showCarrierBlockCallError, setShowCarrierBlockCallError] =
    useState(false)
  const [device, setDevice] = useState(null)
  const [suggestions, setSuggestions] = useState([])
  const [currentConferenceName, setCurrentConferenceName] = useState("")
  const [callingPhone, setCallingPhone] = useState(false)
  const [participantsCallsSid, setParticipantsCallsSid] = useState([])
  const [connection, setConnection] = useState(null)
  const currentConferenceNameRef = useRef(currentConferenceName)
  const toNumbersRef = useRef(toNumbers)
  const activeCallRef = useRef(activeCall)

  const handleError = (err) => {
    let errorMge = "Error while fetching numbers."
    if (err.response && err.response.status === 400) {
      errorMge = err.response.data
    }
    setErrorFindingNumbers(errorMge)
  }

  const findNumbers = useCallback(() => {
    setLoadingNumbers(true)
    let _fromNumbers = []
    trApiFindStaffAndOrgNumber(
      userCtx.tokens.getTelerecoveryToken(),
      userCtx.session.user.staff_id,
      userCtx.session.user.organization_id,
      userCtx.session.user.organization_alias,
      userCtx.session.user.staff_alias,
    ).then(
      (response) => {
        if (response.staffNumber) {
          _fromNumbers.push({
            label: `${formatPhoneNumber(response.staffNumber)} (Yours)`,
            value: response.staffNumber,
          })
        }
        if (response.orgNumber) {
          _fromNumbers.push({
            label: `${formatPhoneNumber(response.orgNumber)} (Organization)`,
            value: response.orgNumber,
          })
        }
        setFromNumbers(_fromNumbers)
        setLoadingNumbers(false)
      },
      (err) => {
        handleError(err)
        setFromNumbers(_fromNumbers)
        setLoadingNumbers(false)
      },
    )
  }, [userCtx.session.user.organization_id, userCtx.session.user.staff_id])

  const getCallHistory = useCallback(() => {
    if (fromNumber !== null) {
      setLoadingCalls(true)
      trApiGetExternalCallHistory(
        userCtx.tokens.getTelerecoveryToken(),
        fromNumber,
      ).then(
        (response) => {
          let callHistoryAux = []

          Array.from(response).forEach((call) => {
            callHistoryAux.push({
              date: moment(call.dateCreated).format("MMMM Do YYYY"),
              time: moment(call.dateCreated).format("h:mm:ss a"),
              duration: call.duration + " seconds",
              from: formatPhoneNumber(fromNumber),
              to: call.to.map((to) => formatPhoneNumber(to)).join(", "),
              errorCode: call.errorCode,
              errorMessage: call.errorMessage,
            })
          })
          setCallHistory(callHistoryAux)
          setLoadingCalls(false)
        },
        (err) => {
          console.log(err)
          setLoadingCalls(false)
        },
      )
    } else {
      setCallHistory([])
    }
  }, [fromNumber])

  const getToken = useCallback(() => {
    trApiGetTwilioAudioToken(
      userCtx.tokens.getTelerecoveryToken(),
      userCtx.session.user.staff_id,
    ).then(
      (response) => {
        if (response.token) {
          let token = response.token
          const newDevice = new Device(token)
          setDevice(newDevice)
        }
      },
      (err) => console.log(err),
    )
  }, [userCtx.session.user.staff_id])

  useEffect(() => {
    findNumbers()
  }, [findNumbers])

  useEffect(() => {
    const fetchPhoneSuggestions = async () => {
      try {
        setLoadingSuggestions(true)
        trApiGetPhoneSuggestions(
          userCtx.tokens.getTelerecoveryToken(),
          fromNumber,
        ).then(
          (response) => {
            setLoadingSuggestions(false)
            const formattedSuggestions = response.map((phoneNumber) =>
              cleanPhoneNumber(phoneNumber),
            )
            setSuggestions(formattedSuggestions)
          },
          (err) => {
            console.log(err)
            setLoadingSuggestions(false)
            setSuggestions([])
          },
        )
      } catch (error) {
        console.error("Error fetching phone suggestions: ", error)
      }
    }
    fetchPhoneSuggestions()
  }, [fromNumber])

  useEffect(() => {
    if (errorFindingNumbers !== null && toast.current !== null) {
      toast.current.show({
        severity: "error",
        detail: errorFindingNumbers,
        life: 3000,
      })
    }
  }, [errorFindingNumbers, toast.current])

  useEffect(() => {
    getCallHistory()
  }, [getCallHistory])

  useEffect(() => {
    getToken()
  }, [getToken])

  useEffect(() => {
    if (device) {
      device.on("registered", () => {
        setIsDeviceReady(true)
        console.log("DEVICE READY")
      })

      device.on("error", (twilioError, call) => {
        console.log("An error has occurred: ", twilioError)
      })

      const registerDevice = async () => {
        try {
          await device.register()
        } catch (error) {
          console.error("Error registering device")
        }
      }
      registerDevice()
    }
  }, [device])

  useEffect(() => {
    const _connection = new HubConnectionBuilder()
      .withUrl(telerecoveryApiUrl() + "/notificationHub")
      .withAutomaticReconnect()
      .build()
    setConnection(_connection)
  }, [])

  const participantJoined = useCallback(
    (confName, phoneNumber) => {
      if (currentConferenceNameRef.current !== confName) return
      setCallingPhone(false)
      // Update calling phone state
      setToNumbers((prevToNumbers) =>
        prevToNumbers.map((n) =>
          n.number === phoneNumber
            ? { number: phoneNumber, calling: false }
            : n,
        ),
      )
    },
    [currentConferenceName, setToNumbers],
  )

  const participantDisconnected = useCallback(
    (confName, phone, callStatus) => {
      if (currentConferenceNameRef.current !== confName) return
      if (toNumbersRef.current.length === 1) hangup(activeCallRef.current)
      console.log(`${phone} disconnected with status: ${callStatus}`)
      setToNumbers(toNumbers.filter((r) => r.number !== phone))
      setParticipantsCallsSid(
        participantsCallsSid.filter((c) => c.number !== phone),
      )
    },
    [currentConferenceName, setToNumbers, toNumbers],
  )

  useEffect(() => {
    if (connection) {
      // Clean up previous listeners to avoid multiple subscriptions
      connection.off("ExternalCallJoin")
      connection.off("ExternalCallDisconnected")

      // Only attempt to start the connection if it's disconnected
      if (connection.state === "Disconnected") {
        connection
          .start()
          .then(() => {
            connection.on("ExternalCallJoin", (conferenceName, phoneNumber) => {
              participantJoined(
                decodeURIComponent(conferenceName),
                decodeURIComponent(phoneNumber),
              )
            })
            connection.on(
              "ExternalCallDisconnected",
              async (conferenceName, phoneNumber, callStatus) => {
                participantDisconnected(
                  decodeURIComponent(conferenceName),
                  decodeURIComponent(phoneNumber),
                  decodeURIComponent(callStatus),
                )
              },
            )
          })
          .catch((e) => console.log("Connection failed: ", e))
      } else {
        // Re-subscribe to the event
        connection.on(
          "ExternalCallJoin",
          (conferenceName, phoneNumber, callSid) => {
            participantDisconnected(
              decodeURIComponent(conferenceName),
              decodeURIComponent(phoneNumber),
              decodeURIComponent(callSid),
            )
          },
        )
        connection.on(
          "ExternalCallDisconnected",
          async (conferenceName, phoneNumber, callStatus) => {
            participantDisconnected(
              decodeURIComponent(conferenceName),
              decodeURIComponent(phoneNumber),
              decodeURIComponent(callStatus),
            )
          },
        )
      }
      // Cleanup function to unregister event handlers
      return () => {
        if (connection) {
          connection.off("ExternalCallJoin")
          connection.off("ExternalCallDisconnected")
        }
      }
    }
  }, [connection])

  useEffect(() => {
    currentConferenceNameRef.current = currentConferenceName
  }, [currentConferenceName])

  useEffect(() => {
    toNumbersRef.current = toNumbers
  }, [toNumbers])

  useEffect(() => {
    activeCallRef.current = activeCall
  }, [activeCall])

  const generateRandomId = () => {
    return "id-" + Math.random().toString(36).substr(2, 9) + "-" + Date.now()
  }

  const createConferenceAndAddFirstParticipant = async () => {
    const _conferenceName = `Conference${generateRandomId()}`
    setCurrentConferenceName(_conferenceName)

    let call = await device.connect({ params: { to: _conferenceName } })
    call.on("accept", async (call) => {
      console.log(
        `Moderator (from: ${fromNumber}) connected to conference: ${_conferenceName}`,
      )
      setIsDeviceReady(true)
      onConnected(call)
      const response = await trApiAddParticipantExternalCall(
        userCtx.tokens.getTelerecoveryToken(),
        { from: fromNumber, to: toNumber, conferenceName: _conferenceName },
      )
      if (response.error) {
        setCallError("Error connecting number. Please try again.")
        setIsOnCall(false)
      } else {
        setParticipantsCallsSid([
          ...participantsCallsSid,
          { number: toNumber, callSid: response.callSid },
        ])
        setToNumbers([...toNumbers, { number: toNumber, calling: true }])
        setToNumber(null)
      }
    })
    call.on("disconnect", () => {
      console.log("Call Disconnected")
      setToNumbers([])
      setToNumber(null)
      setIsOnCall(false)
      setParticipantsCallsSid([])
    })
    call.on("error", (error) => {
      setToNumbers([])
      setToNumber(null)
      setIsOnCall(false)
      setParticipantsCallsSid([])
      console.log("Call Error:" + error)
    })
  }

  const onConfirmCallBack = useCallback(() => {
    hangup(activeCall)
  })

  usePrompt(
    "Leaving this page with a telerecovery session in progress will end the session. Are you sure you wish to navigate away?",
    isOnCall,
    onConfirmCallBack,
  )

  const call = async () => {
    if (!activeCall && validatePhoneNumber(toNumber)) {
      setCallError("")
      setShowCarrierBlockCallError(false)
      try {
        setIsDeviceReady(false)
        await createConferenceAndAddFirstParticipant()
      } catch (e) {
        setCallError("Error connecting call. Please try again.")
        setIsOnCall(false)
      }
    }
  }

  /**
   * Hangs up the call
   */
  const hangup = (call) => {
    if (call) call.disconnect()
    setStatus("No call in progress.")
    setActiveCall(null)
    setIsOnCall(false)
    setIsMuted(false)
    setParticipantsCallsSid([])
    getCallHistory()
  }

  const onConnected = (call) => {
    setStatus("Call in progress.")
    setCallError("")
    setShowCarrierBlockCallError(false)
    setActiveCall(call)
    userCtx.setIncomingCallPickedUp("SI")
    setIsOnCall(true)

    call.on("error", (error) => {
      console.log(error)
    })
    call.on("disconnect", (call) => {
      hangup(activeCall)
    })
  }

  const muteOnOff = () => {
    if (activeCall) {
      activeCall.mute(!isMuted)
      setIsMuted(!isMuted)
    }
  }

  if (loadingNumbers === true) {
    return (
      <>
        <PageSidebarContent>
          <AdditionalServicesSidebar />
        </PageSidebarContent>
        <LoaderFullPage></LoaderFullPage>
      </>
    )
  }

  const submitHangup = async () => {
    if (activeCall) {
      const response = await trApiDisconnectExternalCall(
        userCtx.tokens.getTelerecoveryToken(),
        { callSids: participantsCallsSid.map((c) => c.callSid) },
      )
      if (response.error) {
        setCallError("Error while disconnecting call")
      }
      //Disconnect the call from the conference
      activeCall.disconnect()
    }
  }

  return (
    <>
      <PageSidebarContent>
        <AdditionalServicesSidebar />
      </PageSidebarContent>
      <Toast ref={toast} />
      <div className={eccss.note}>
        Please note that using the external dialer allows for phone calls with a
        single number or multiple numbers (a group call) to be placed from
        either your staff telerecovery number or the organization’s telerecovery
        number. The external dialer does not accept incoming calls and may only
        be used to place outgoing external calls.
      </div>
      <div className={eccss.heading}>
        <h1>External Calls</h1>
        <hr />
      </div>
      <div
        className={styles.wrapper}
        style={{ margin: "0px", height: "calc(100vh - 235px)" }}
      >
        <div
          className={styles.conversations_menu}
          style={{ backgroundColor: "#e7e0f180", padding: "0 20px" }}
        >
          {!activeCall ? (
            <div style={{ paddingTop: "20px" }}>
              <div className={eccss.field}>
                <label className={eccss.label}>From</label>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                  }}
                >
                  {fromNumbers.map((number, index) => (
                    <div
                      key={index}
                      className={classNames(
                        eccss.radio_btn,
                        eccss.noFocusOverrides,
                      )}
                    >
                      <RadioButton
                        disabled={loadingCalls}
                        inputId={number.value}
                        value={number.value}
                        onChange={(e) => setFromNumber(e.value)}
                        style={{ margin: "0" }}
                        checked={fromNumber === number.value}
                      />
                      <label
                        htmlFor={number.value}
                        className={eccss.inline_label}
                      >
                        {number.label}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
              <div className={eccss.field}>
                <label className={eccss.label}>To</label>
                <PhoneAutocomplete
                  suggestions={suggestions}
                  value={toNumber}
                  setValue={setToNumber}
                  loading={loadingSuggestions}
                />
              </div>
            </div>
          ) : (
            <div style={{ paddingTop: "20px" }}>
              <h3
                style={{
                  textAlign: "center",
                  fontSize: "16px",
                  marginBottom: "15px",
                }}
              >
                Active Call
              </h3>
              <ul
                style={{
                  fontSize: "12px",
                  marginBottom: "1rem",
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px",
                }}
              >
                {toNumbers.map((n, index) => (
                  <li
                    key={index}
                    style={{
                      background: "white",
                      borderRadius: "4px",
                      border: "1px solid #E7E0F1",
                      padding: "6px 8px",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <div
                      style={{
                        color: "#495057",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          gap: "8px",
                          alignItems: "center",
                        }}
                      >
                        <img
                          src={participant_icon}
                          alt="participant"
                          style={{ height: "16px" }}
                        />
                        {formatPhoneNumber(n.number)}
                      </div>
                      {n.calling && (
                        <div style={{ width: "3.1rem" }}>
                          Calling <span className={eccss.dots}></span>
                        </div>
                      )}
                    </div>
                    {
                      <Button
                        icon={
                          <img src={remove_icon} style={{ height: "12px" }} />
                        }
                        onClick={async () => {
                          if (toNumbers.length === 1) hangup(activeCall)
                          //get callSid of the participant to disconnect
                          const callSid = participantsCallsSid.filter(
                            (c) => c.number === n.number,
                          )[0].callSid
                          const response = await trApiDisconnectExternalCall(
                            userCtx.tokens.getTelerecoveryToken(),
                            { callSids: [callSid] },
                          )
                          if (response.error) {
                            setCallError("Error while disconnecting call")
                          } else {
                            setToNumbers(
                              toNumbers.filter((r) => r.number !== n.number),
                            )
                            setParticipantsCallsSid(
                              participantsCallsSid.filter(
                                (c) => c.number !== n.number,
                              ),
                            )
                          }
                        }}
                        style={{
                          background: "transparent",
                          border: "none",
                          padding: "0",
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      />
                    }
                  </li>
                ))}
              </ul>
              <div className={eccss.field} style={{ marginBottom: "0" }}>
                <label className={eccss.label}>Add phone number</label>
                <PhoneAutocomplete
                  suggestions={suggestions}
                  value={toNumber}
                  setValue={setToNumber}
                  loading={loadingSuggestions || callingPhone}
                  icon={send_icon}
                  iconAction={async (number) => {
                    setCallingPhone(true)
                    const response = await trApiAddParticipantExternalCall(
                      userCtx.tokens.getTelerecoveryToken(),
                      {
                        from: fromNumber,
                        to: number,
                        conferenceName: currentConferenceName,
                        endConferenceOnExit: false,
                      },
                    )
                    if (response.error) {
                      setCallError("Error connecting number. Please try again.")
                      setCallingPhone(false)
                    } else {
                      setToNumbers([
                        ...toNumbers,
                        { number: number, calling: true },
                      ])
                    }
                  }}
                />
              </div>
            </div>
          )}
          {fromNumbers.length > 0 && (
            <div
              style={{
                backgroundColor: "white",
                border: "1px solid #ced4da",
                borderRadius: "12px",
                marginTop: "1rem",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div style={{ padding: "15px", textAlign: "center" }}>
                <PhoneKeypad
                  playSound={!activeCall}
                  onKeyPress={(key) => {
                    if (activeCall) {
                      setToNumber(toNumber ? toNumber + key : key)
                      activeCall.sendDigits(key)
                    } else {
                      const _number = toNumber ? toNumber + key : key
                      setToNumber(formatPhoneNumberInput(_number))
                    }
                  }}
                />
                {!activeCall ? (
                  <Button
                    label="Start Audio Call"
                    className="btn startAudioCallBtn"
                    onClick={call}
                    style={{
                      borderRadius: "28px",
                      height: "58px",
                      width: "85%",
                      fontSize: "18px",
                    }}
                    disabled={
                      !isDeviceReady || fromNumber === null || toNumber === null
                    }
                  />
                ) : (
                  <>
                    <p
                      style={{
                        color: "#383838",
                        fontSize: "14px",
                        fontWeight: "700",
                      }}
                    >
                      {status}
                    </p>
                    <div style={{ color: "#383838", fontSize: "14px" }}>
                      {status === "Call in progress." ? (
                        <AudioSessionTimer startTime={new Date()} />
                      ) : (
                        <div className="sessionTimer">0:0:00</div>
                      )}
                    </div>
                    <div className={eccss.call_buttons}>
                      <Button
                        icon={
                          <img
                            src={!isMuted ? mic_icon : mic_off_icon}
                            alt="mic"
                            style={{ height: "24px" }}
                          />
                        }
                        className={!isMuted ? eccss.mute : eccss.unmute}
                        onClick={muteOnOff}
                      />
                      <Button
                        icon={
                          <img
                            src={hangup_icon}
                            alt="hangup"
                            style={{ height: "24px" }}
                          />
                        }
                        onClick={() =>
                          //activeCall && activeCall.disconnect()
                          submitHangup()
                        }
                      />
                    </div>
                  </>
                )}
              </div>
              {(showCarrierBlockCallError || callError) && (
                <div
                  style={{ margin: "10px", textAlign: "center", color: "red" }}
                >
                  <CallErrorPopup
                    showPopup={showCarrierBlockCallError}
                    setShowPopup={setShowCarrierBlockCallError}
                  />
                  {!showCarrierBlockCallError && callError}
                </div>
              )}
              <div style={{ textAlign: "center", padding: "0 1rem 1rem 1rem" }}>
                <p style={{ fontSize: "14px" }}>
                  Your call will end if you navigate from this page.
                </p>
              </div>
            </div>
          )}
        </div>
        <CallHistory
          callHistory={callHistory}
          loadingCalls={loadingCalls}
          refresh={getCallHistory}
        />
      </div>
    </>
  )
}

export default ExternalCalls
